import { Instance } from 'mobx-state-tree';
import useMst from '~/src/hooks/useMst';
import { LAYOUT_SLIDEIN_TYPES } from '~/src/components/PageLayout/SlideIns';
import { PdfCourtFormStore } from '~/src/stores/pdfCourtFormsStore';
import { useLayoutContext } from '../contexts/Layout';

interface PdfCourtForm extends Instance<typeof PdfCourtFormStore> {}

const usePdfCourtFormsActions = () => {
  const { showSlideIn } = useLayoutContext();

  const {
    addTemplateToSeletionSidebar,
    addSearchResultToSelectionSidebar,
    seedSearchResult,
    createFormTemplate,
  } = useMst((store) => ({
    addTemplateToSeletionSidebar:
      store.pdfCourtForms.addTemplateToSeletionSidebar,
    addSearchResultToSelectionSidebar:
      store.pdfCourtForms.addSearchResultToSelectionSidebar,
    seedSearchResult: store.pdfCourtForms.seedSearchResult,
    createFormTemplate: store.pdfCourtForms.createFormTemplate,
  }));

  const handleAddTemplateToSeletionSidebar = (template: PdfCourtForm) => {
    addTemplateToSeletionSidebar(template);
  };

  const handleAddSearchResultToSelectionSidebar = (template: PdfCourtForm) => {
    addSearchResultToSelectionSidebar(template);
  };

  const handlePreviewTemplate = (template: PdfCourtForm) => {
    showSlideIn(LAYOUT_SLIDEIN_TYPES.documentPreview, {
      largeSlideIn: true,
      templateObj: template,
      templateId: template.id,
    });
  };

  // Master search results arrive raw from the search API (snake_case, absent
  // from the store dictionary). Seed + map them first so the preview slide-in
  // sees a `documentCategoryId` and can resolve the template by id, the same
  // way a folder-navigated form does.
  const handlePreviewSearchResult = (searchResult: PdfCourtForm) => {
    handlePreviewTemplate(seedSearchResult(searchResult));
  };

  return {
    addTemplateToSeletionSidebar: handleAddTemplateToSeletionSidebar,
    addSearchResultToSelectionSidebar: handleAddSearchResultToSelectionSidebar,
    previewTemplate: handlePreviewTemplate,
    previewSearchResult: handlePreviewSearchResult,
    createFormTemplate,
  };
};

export default usePdfCourtFormsActions;
